import React, {FC} from 'react';

import {globalWindow} from '../../../../../../../libs/shared/helpers/src/browser/browserHelpers';
import {Trans} from '../../../../../../../libs/shared/helpers/src/internationalization/react';
import {useUserTheme} from '../../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {MessageModel} from '../../../../../../models/api/messageModel';
import {MessageBanner} from './messageBanner';
import {MessageBannerAction} from './messageBannerAction';
import {MessageBannerActionGroup} from './messageBannerActionGroup';
import {MessageBannerSubtitle} from './messageBannerSubtitle';
import {MessageBannerTitle} from './messageBannerTitle';

/*
 * Props.
 */

interface MissingBodyBannerProps {
  message: MessageModel;
  isRounded: boolean;
}

/*
 * Component.
 */

export const MissingBodyMessageBanner: FC<MissingBodyBannerProps> = (props) => {
  const theme = useUserTheme();
  const encodedSearchTerm = encodeURIComponent(`rfc822msgid:${props.message.extId}`);
  const openInGmailLink = `https://mail.google.com/mail/u/0/#search/${encodedSearchTerm}`;
  return (
    <MessageBanner
      color={theme.palette.red.shade40}
      iconName="warningFilledSmall"
      iconColor={theme.greys.white}
      isRounded={props.isRounded}
    >
      <MessageBannerTitle color={theme.greys.white}>
        <Trans id="missing-body-title">Failed to load message</Trans>
      </MessageBannerTitle>
      <MessageBannerSubtitle>
        <Trans id="missing-body-subtitle">Message is too large</Trans>
      </MessageBannerSubtitle>
      <MessageBannerActionGroup>
        <MessageBannerAction onClick={() => globalWindow.open(openInGmailLink)}>
          <Trans id="missing-body-external-link">View In Gmail</Trans>
        </MessageBannerAction>
      </MessageBannerActionGroup>
    </MessageBanner>
  );
};
